export default {
  containerClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('containerClass', '')
    }
  },
  emptyCartClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('emptyCartClass', '')
    }
  },
  emptyCartTitle: {
    type: [String],
    default() {
      return this.$options.$$t('emptyCartTitle', 'Cart is empty')
    }
  },
  showShopButtonOnEmpty: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showShopButtonOnEmpty', true)
    }
  },
  shopButtonClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('shopButtonClass', '')
    }
  },
  shopButtonTitle: {
    type: [String],
    default() {
      return this.$options.$$t('shopButtonTitle', 'Continue shopping')
    }
  },
  showCount: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showCount', true)
    }
  },
  countContainerClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('countContainerClass', '')
    }
  },
  countClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('countClass', '')
    }
  },
  iconClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('iconClass', '')
    }
  },
  itemClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemClass', '')
    }
  },
  itemMediaClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemMediaClass', '')
    }
  },
  showItemImage: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showItemImage', true)
    }
  },
  itemImageClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemImageClass', '')
    }
  },
  itemTitleClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemTitleClass', '')
    }
  },
  itemPriceClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemPriceClass', '')
    }
  },
  itemQuantityClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemQuantityClass', '')
    }
  },
  itemDeleteClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('itemDeleteClass', '')
    }
  },
  cartLink: {
    type: [String, Object],
    default() {
      return this.$options.$$s('cartLink', { name: 'cart' })
    }
  },
  cartLinkLabel: {
    type: String,
    default() {
      return this.$options.$$t('cartLinkLabel', 'Go to Cart')
    }
  },
  cartLinkClass: {
    type: String,
    default() {
      return this.$options.$$s('cartLinkClass', 'btn')
    }
  },
  noClose: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('noClose')
    }
  }
}
